<div class="bo-subheader">
  JNJ MedTech TASKit AI proficiency assessment:
  <span class="!text-bo-primary">{{
    valid() ? (level() | translate) : 'N/A'
  }}</span>
</div>
@if (valid()) {
  <div class="relative mt-3 h-5 w-full rounded-full bg-bo-primary/20">
    <div
      class="absolute top-0 h-5 w-1/2 rounded-full bg-bo-primary/40"
      [style.width.%]="levels().expert"
    ></div>
    <div
      class="absolute top-0 h-5 w-1/3 rounded-full bg-bo-primary/60"
      [style.width.%]="levels().intermediate"
    ></div>
    <div class="relative flex">
      <div class="flex-1"></div>

      <div
        class="border-3 size-5 rounded-full border-solid border-bo-black bg-bo-white"
      ></div>
      <div [style.width.%]="100 - score()"></div>
    </div>
  </div>
  <div class="bo-title flex w-full">
    <div [style.width.%]="levels().intermediate">Beginner</div>
    <div class="flex flex-1 justify-between">
      <div>Intermediate</div>
      <div>Expert</div>
    </div>
  </div>
}
